<div class="layout-grid">
  <div class="notification-banner__content">
    <div class="notification-banner__message">
      @if (icon) {
        <mat-icon>{{icon}}</mat-icon>
      }
      <p [innerHTML]="message"></p>
    </div>

    <div class="notification-banner__actions">
      @if (dismissAction && !dismissAction.href) {
        <button type="button" matButton (click)="onClick_dismissAction()">
          {{dismissAction.text}}
        </button>
      }
      @if (dismissAction && dismissAction.href) {
        <a [routerLink]="dismissAction.href" [state]="dismissAction.hrefState" matButton>
          {{dismissAction?.text}}
        </a>
      }

      @if (resolveAction?.click) {
        <button type="button" matButton (click)="onClick_resolveAction()">
          {{resolveAction?.text}}
        </button>
      }
      @if (resolveAction?.href) {
        <a [routerLink]="resolveAction.href" [state]="resolveAction.hrefState" matButton>
          {{resolveAction?.text}}
        </a>
      }
    </div>
  </div>
</div>